module.exports = __webpack_public_path__ + "static/media/info_black.2226ccec.svg";